import React, { memo } from "react";
import { StatusBar, StyleSheet, View } from "react-native";
import { SafeAreaProvider, useSafeAreaInsets } from "react-native-safe-area-context";
import { KeyboardProvider } from "react-native-keyboard-controller";
import OpenSettingsModal from "@screens/LocationServiceablity/OpenSettingsModal";
import SnackBarComponent from "@components/SnackBar";
import SuspensionModal from "@components/SuspensionModal";
import FaceCaptureModal from "@components/FaceCapture";
import color from "@constants/color";
import RootContainer from "./Main";

function AppContent() {
  const insets = useSafeAreaInsets();
  return (
    <View style={[styles.container, { paddingTop: insets.top, paddingBottom: insets.bottom }]}>
      <StatusBar barStyle="dark-content" />
      <RootContainer />
      <SnackBarComponent />
      <OpenSettingsModal />
      <SuspensionModal />
      <FaceCaptureModal />
    </View>
  );
}

const App = memo(() => (
  <SafeAreaProvider>
    <KeyboardProvider>
      <AppContent />
    </KeyboardProvider>
  </SafeAreaProvider>
));

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default App;
